// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blox-up-text[data-v-f53dde5c]{width:123px;height:24px;font-family:Druk Text Wide Cyr;font-style:normal;font-weight:900;font-size:20px;line-height:24px;text-transform:uppercase}.blox-up-text span[data-v-f53dde5c]{background:var(--text-gradient-165);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
